<template>
  <div>
    <head-nav-bar title="点菜" :fixed="true" />
    <div class="mt-header-nav restaurant-box">
      <van-row
        type="flex"
        justify="space-between"
        style="border-bottom: 1px solid #f2f2f2;"
      >
        <van-col span="5" class="food-sidebar">
          <van-sidebar v-model="foodClassKey">
            <van-sidebar-item
              v-for="item in foodClassList"
              :title="item.CategoryName"
              :key="item.CategoryId"
              @click="foodClassChange($event, item)"
            />
          </van-sidebar>
        </van-col>
        <van-col span="19">
          <van-list
            :finished="finished"
            v-model="loading"
            finished-text="没有更多了"
            class="food-list"
          >
            <lazy-component>
              <div
                v-for="item in foodList"
                :key="item.DishId"
                class="food-item"
              >
                <span class="sold-out" v-if="item.IsSoldOut"></span>
                <van-card :class="{ disabled: item.IsSoldOut }">
                  <template slot="price">
                    ￥{{
                      tableInfo.IsMember && item.MemberUnitPrice != null
                        ? item.MemberUnitPrice
                        : item.UnitPrice
                    }}
                    <van-tag
                      type="success"
                      round
                      v-if="tableInfo.IsMember && item.MemberUnitPrice != null"
                      >会</van-tag
                    >
                  </template>
                  <template slot="thumb">
                    <img v-lazy="item.ImageUrl ? item.ImageUrl : noPic" />
                  </template>
                  <template #title>
                    <div class="food-title">
                      <span>
                        {{ item.DishName }}/<em>{{ item.UnitName }}</em></span
                      >
                      <span v-if="item.IsPack" @click="openPack(item)">
                        <van-tag color="#f60"
                          >套餐 &nbsp;<van-icon
                            :name="
                              openKeys.includes(item.DishId) ||
                              openKeys.includes(item.Id)
                                ? 'arrow-up'
                                : 'arrow-down'
                            "
                          />
                        </van-tag>
                      </span>
                    </div>
                  </template>
                  <template v-if="item.IsPack" #footer>
                    <ul
                      class="pack-detail"
                      :class="{
                        'pack-detail-open':
                          openKeys.includes(item.DishId) ||
                          openKeys.includes(item.Id),
                      }"
                    >
                      <li v-for="pack in item.PackDetails" :key="pack.Id">
                        {{ pack.Name }} x {{ pack.Quantity }}
                      </li>
                    </ul>
                  </template>
                  <template #num>
                    <span
                      class="theme-round"
                      v-if="!item.Quantity || item.Quantity == '0'"
                    >
                      <span
                        class=" van-stepper__plus add-btn"
                        @click="addFood(item)"
                      >
                      </span
                    ></span>

                    <van-stepper
                      class="theme-round"
                      style="text-align: right;"
                      @change="onStepperChange($event, item)"
                      @focus="onFocus"
                      v-model="item.Quantity"
                      :min="0"
                      :decimal-length="0"
                      v-else
                    />
                  </template>
                </van-card>
              </div>
            </lazy-component>
          </van-list>
        </van-col>
      </van-row>
      <van-goods-action>
        <div
          slot="default"
          class="summary-info"
          style="width:60%"
          @click="checkDetail"
        >
          <span>
            <van-icon name="shopping-cart-o" />总数：<em
              >{{ total.Quantity }}
            </em></span
          >
          <span>
            <van-icon name="balance-o" />总计：<em
              >&yen; {{ total.TotalPrice }}</em
            >
          </span>
        </div>
        <van-goods-action-button
          type="danger"
          text="选好了"
          @click="createOrder"
        />
      </van-goods-action>
    </div>
    <van-popup
      v-model="visible"
      position="bottom"
      closeable
      :style="{ height: '50%' }"
    >
      <h3 class="selected-title pop-selected-title">已选择菜品</h3>
      <lazy-component>
        <div class="select-foods">
          <template v-for="el in foodClassList">
            <template v-for="item in el.DishList">
              <van-card
                :price="
                  tableInfo.IsMember && item.MemberUnitPrice != null
                    ? item.MemberUnitPrice
                    : item.UnitPrice
                "
                :key="item.DishId"
                v-if="Number(item.Quantity) > 0"
              >
                <template #title>
                  <div class="food-title">
                    <span>
                      {{ item.DishName }}/<em>{{ item.UnitName }}</em>
                      <van-tag color="#f60" v-if="item.IsPack" round
                        >套</van-tag
                      >
                      <van-button
                        v-if="!item.IsPack"
                        type="primary"
                        size="mini"
                        @click="addCookingMethod(item)"
                        >做法</van-button
                      >
                      <span
                        v-if="item.PracticeDesc || item.CookingMethodDesc"
                        class="method-txt"
                      >
                        「做法」{{ item.PracticeDesc
                        }}{{ item.CookingMethodDesc }}
                      </span>
                    </span>
                  </div>
                </template>

                <template #num>
                  <van-stepper
                    class="theme-round"
                    style="text-align: right;"
                    @change="onStepperChange($event, item)"
                    @focus="onFocus"
                    v-model="item.Quantity"
                    :min="0"
                    :decimal-length="0"
                  />
                </template>
              </van-card>
            </template>
          </template>
        </div>
      </lazy-component>
    </van-popup>
    <van-dialog
      v-model="showMethod"
      title="选择做法"
      @confirm="onSubmitMethod"
      show-cancel-button
    >
      <van-grid :gutter="10" class="cooking-methods">
        <van-grid-item
          v-for="item in cookingMethods"
          :key="item.Id"
          :text="item.Text"
          @click="chooseMethod(item)"
          :class="{ active: selectMethodIds.includes(item.Id) }"
        />
      </van-grid>
    </van-dialog>
    <van-dialog
      v-model="showMethodDesc"
      title="手写做法"
      @confirm="onSubmitMethodDesc"
      show-cancel-button
    >
      <van-field v-model="CookingMethodDesc" label="做法" clearable />
    </van-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Row,
  Col,
  Icon,
  Sidebar,
  Search,
  Stepper,
  SidebarItem,
  List,
  Cell,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Card,
  Tag,
  Popup,
  Notify,
  Lazyload,
  Button,
  Grid,
  GridItem,
  Field,
  Dialog,
} from "vant";
Vue.use(Lazyload, {
  lazyComponent: true,
});
import { accAdd, accMul } from "@/utils/common";
import noPic from "@/assets/images/nopic.png";
import "./rms.less";
import { ls } from "@/utils/cache.js";
import restaurantApi from "@/api/restaurant.js";
import { cloneDeep } from "lodash";
import { getSelectData } from "@/api/common.js";
export default {
  name: "OrderFood",
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Grid.name]: Grid,
    [Field.name]: Field,
    [GridItem.name]: GridItem,
    [Button.name]: Button,
    [Notify.name]: Notify,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Row.name]: Row,
    [Col.name]: Col,
    [Search.name]: Search,
    [Stepper.name]: Stepper,
    [Sidebar.name]: Sidebar,
    [SidebarItem.name]: SidebarItem,
    [List.name]: List,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [Cell.name]: Cell,
  },
  watch: {
    foodClassList: {
      handler: function(list) {
        let total = 0,
          num = 0;
        list.forEach(el => {
          el.DishList.forEach(item => {
            item.Quantity = item.Quantity ? item.Quantity : 0;
            item.TotalPrice = item.TotalPrice ? item.TotalPrice : 0;
            num = accAdd(num, item.Quantity);
            total = accAdd(total, item.TotalPrice);
          });
        });

        this.total.Quantity = num;
        this.total.TotalPrice = total;
      },
      deep: true,
    },
  },
  data() {
    return {
      noPic,
      foodClassKey: "0",
      foodClassList: [],
      foodList: [],
      loading: false,
      finished: true,
      total: {
        Quantity: 0,
        TotalPrice: 0,
      },
      visible: false,
      orderId: "",
      cookingMethods: [],
      showMethod: false,
      selectMethodIds: [],
      CookingMethodDesc: "",
      showMethodDesc: false,
      orderData: [],
      tableInfo: {},
      openKeys: [],
    };
  },
  beforeRouteLeave(to, from, next) {
    if (!this.orderId && to.name == "restaurantBookingIndex") {
      next(false);
      Dialog.confirm({
        title: "确定取消下单吗？",
      })
        .then(() => {
          next(true);
        })
        .catch(() => {
          next(false);
        });
    } else {
      next();
    }
  },
  created() {
    // ls.remove("order_data");
    this.orderData = ls.get("order_data");
    this.tableInfo = ls.get("order_table_info");
    this.orderId = this.$route.query.OrderId;
    getSelectData({
      Types: "CookingMethod",
    }).then(res => {
      this.cookingMethods = res.Data.CookingMethod;
      this.cookingMethods.push({
        Id: "0",
        Text: "手写",
      });
    });
    this.fetchFoodList();
  },
  methods: {
    openPack(item) {
      let id = item.Id ? item.Id : item.DishId;
      if (this.openKeys.includes(id)) {
        this.openKeys = this.openKeys.filter(el => el != id);
      } else {
        this.openKeys.push(id);
      }
    },
    fetchFoodList() {
      restaurantApi
        .getDishList({ OnlyInSelling: false, IsPack: true })
        .then(res => {
          this.foodClassList = res.Data;
          this.foodClassList.forEach(el => {
            el.DishList.forEach(item => {
              if (this.orderData && this.orderData.length) {
                const obj = this.orderData.find(
                  ele => ele.DishId == item.DishId,
                );
                item.Quantity = obj ? obj.Quantity : 0;
                item.TotalPrice = obj ? obj.TotalPrice : 0;
              } else {
                item.Quantity = 0;
                item.TotalPrice = 0;
              }

              item.ImageUrl = item.ImageUrl
                ? this.$config.http.serverUrl + item.ImageUrl
                : "";
            });
          });
          this.foodList = cloneDeep(res.Data[0].DishList);
          this.foodClassList[0].DishList = this.foodList;
        });
    },
    foodClassChange(index) {
      const data = cloneDeep(this.foodClassList[index].DishList);
      this.foodList = data;
      this.foodClassList[index].DishList = this.foodList;
      this.openKeys = [];
    },
    addCookingMethod(item) {
      this.showMethod = true;
      this.currentFood = item;
      this.selectMethodIds =
        item.CookingMethodIds && item.CookingMethodIds.length
          ? item.CookingMethodIds
          : [];
    },
    onSubmitMethod() {
      this.currentFood.CookingMethodIds = this.selectMethodIds;
      this.currentFood.PracticeDesc = this.cookingMethods
        .filter(p => this.selectMethodIds.includes(p.Id))
        .map(p => p.Text)
        .join(",");
    },
    chooseMethod(item) {
      if (item.Id == 0) {
        this.showMethodDesc = true;
        this.CookingMethodDesc = this.currentFood.CookingMethodDesc;
      } else if (this.selectMethodIds.includes(item.Id)) {
        this.selectMethodIds = this.selectMethodIds.filter(el => el != item.Id);
      } else {
        this.selectMethodIds.push(item.Id);
      }
    },
    onSubmitMethodDesc() {
      this.currentFood.CookingMethodDesc = this.CookingMethodDesc;
      this.showMethod = false;
    },
    addFood(item) {
      if (item.IsSoldOut) {
        return false;
      }
      item.Quantity = Number(item.Quantity) + 1;
      const price =
        this.tableInfo.IsMember && item.MemberUnitPrice != null
          ? item.MemberUnitPrice
          : item.UnitPrice;
      item.TotalPrice = accMul(item.Quantity, price);
    },
    onStepperChange(val, item) {
      const price =
        this.tableInfo.IsMember && item.MemberUnitPrice != null
          ? item.MemberUnitPrice
          : item.UnitPrice;
      item.TotalPrice = accMul(item.Quantity, price);
    },
    onFocus(e) {
      e.currentTarget.select();
    },
    checkDetail() {
      this.visible = true;
    },
    delItem(item) {
      item.Quantity = 0;
      item.TotalPrice = 0;
    },
    createOrder() {
      ls.remove("order_data");
      let list = [];
      this.foodClassList.forEach(el => {
        const data = el.DishList.filter(item => Number(item.Quantity) > 0);
        list = list.concat(data);
      });
      if (!list.length) {
        Notify({ type: "danger", message: "您还没有选择任何菜品" });
        return false;
      }
      ls.set("order_data", list);
      this.$router.push({
        name: "restaurantConfirmOrder",
        query: { OrderId: this.orderId },
      });
    },
  },
};
</script>
<style lang="less"></style>
